import VisualsModel from './visuals.model'


let storeContent = utils.generateStore({
   VisualsModel,
   visuals: [],
   resetForm: false,
   resetFormUpdate: false,
   selected_visuals: [],
   vue_comp: null
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async wizardNextVisual(ctx,payload){
         try {
            let VisualsModel = ctx.getters.VisualsModel, form = await ctx.dispatch('getVisualFromForm',payload.data.type);
            
            if(!ctx.getters.showEditModal){
               VisualsModel.forms.nextPageVisualization.forms = VisualsModel.forms[form].forms
               ctx.commit('VisualsModel',VisualsModel)
            }
         } catch (err) {
            throw err
         }
      },
      getVisualFromForm(ctx,type){
         if(type === 'stat_card'){
            return 'stat_card';
         }else if(type === 'map'){
            return 'map_visual';
         }else if(type === 'region_map'){
            return 'map_region_visual';
         }else if(type === 'pie' || type === 'doughnut'){
            return 'pie_visual';
         }else if(type === 'line' || type === 'area' || type === 'bar'){
            return 'line_visual';
         }else if(type === 'calendar_week' || type === 'calendar'){
            return 'calendar_visual';
         }else{
            return 'stat_card';
         }
      },
      async addVisuals(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.data

            let getField = (field) => {
               if(field && field.selected_option === 'current_table'){
                  if(Array.isArray(field.form_data.field)){
                     let axis = []

                     for (let i = 0; i < field.form_data.field.length; i++) {
                        axis.push({
                           table: data.table,
                           field: field.form_data.field[i],
                           criteria: field.form_data.criteria,
                        })
                     }

                     return axis
                  }else{
                     return [{
                        table: data.table,
                        field: field.form_data.field,
                        criteria: field.form_data.criteria,
                     }]
                  }
               }else{
                  if(field && field.selected_option === 'other_table'){
                     if(Array.isArray(field.form_data.field)){
                        let axis = []
   
                        for (let i = 0; i < field.form_data.field.length; i++) {
                           axis.push({
                              table: field.form_data.other_table,
                              field: field.form_data.field[i],
                              criteria: field.form_data.criteria,
                           })
                        }
   
                        return axis
                     }else{
                        return [{
                           table: field.form_data.other_table,
                           field: field.form_data.field,
                           criteria: field.form_data.criteria,
                        }]
                     }
                  }else{
                     return []
                  }
               }
            }

            // set date field if available
            let date_field = getField(data.date_field)
            if(date_field?.length > 0){
               date_field = date_field[0]
            }else{
               date_field = undefined
            }

            await api.fetchEndpoint({
               resource: 'commons',
               action: 'insert',
               data: {
                  record: {
                     icon: data.icon,
                     type: data.type,
                     sub_type: data.sub_type,
                     country: data.country,
                     name: data.name,
                     class: data.class,
                     index: data.index,
                     table: data.table,
                     orientation: data.orientation,
                     x_fields: getField(data.x_field),
                     y_fields: getField(data.y_field),
                     sort_field: getField(data.sort_field),
                     date_field: date_field,
                     aggregation_fields: getField(data.aggregation_field),
                     description: data.description,
                     limit: data.limit,
                     dashboard_link: data.dashboard_link,
                     date_group_format: data.date_group_format,
                     stacked: data.stacked,
                     last_days: data.last_days,
                     has_date: date_field !== undefined ? true : false,
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "visualization",
               }
            })

            // await ctx.dispatch('fetchVisuals')
            ctx.commit('show_create_modal', false)
            ctx.commit('resetForm', true)
            location.reload();
            $notify('success', 'Visuals Created', `Visuals ${data.name} successfully created.`, 5)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async updateVisuals(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.data

            let getField = (field) => {
               if(field && field.selected_option === 'current_table'){
                  if(Array.isArray(field.form_data.field)){
                     let axis = []

                     for (let i = 0; i < field.form_data.field.length; i++) {
                        axis.push({
                           table: data.table,
                           field: field.form_data.field[i],
                           criteria: field.form_data.criteria,
                        })
                     }

                     return axis
                  }else{
                     return [{
                        table: data.table,
                        field: field.form_data.field,
                        criteria: field.form_data.criteria,
                     }]
                  }
               }else{
                  if(field && field.selected_option === 'other_table'){
                     if(Array.isArray(field.form_data.field)){
                        let axis = []
   
                        for (let i = 0; i < field.form_data.field.length; i++) {
                           axis.push({
                              table: field.form_data.other_table,
                              field: field.form_data.field[i],
                              criteria: field.form_data.criteria,
                           })
                        }
   
                        return axis
                     }else{
                        return [{
                           table: field.form_data.other_table,
                           field: field.form_data.field,
                           criteria: field.form_data.criteria,
                        }]
                     }
                  }else{
                     return []
                  }
               }
            }

            // set date field if available
            let date_field = getField(data.date_field)
            if(date_field?.length > 0){
               date_field = date_field[0]
            }else{
               date_field = undefined
            }

            await api.fetchEndpoint({
               resource: 'commons',
               action: 'update',
               data: {
                  id: ctx.getters.selected_visuals[0]._id,
                  record: {
                     icon: data.icon,
                     type: data.type,
                     sub_type: data.sub_type,
                     country: data.country,
                     name: data.name,
                     class: data.class,
                     index: data.index,
                     table: data.table,
                     orientation: data.orientation,
                     x_fields: getField(data.x_field),
                     y_fields: getField(data.y_field),
                     sort_field: getField(data.sort_field),
                     date_field: date_field,
                     aggregation_fields: getField(data.aggregation_field),
                     description: data.description,
                     limit: data.limit,
                     dashboard_link: data.dashboard_link,
                     date_group_format: data.date_group_format,
                     stacked: data.stacked,
                     last_days: data.last_days,
                     has_date: date_field !== undefined ? true : false,
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "visualization",
               }
            })

            // await ctx.dispatch('fetchVisuals')
            ctx.commit('show_edit_modal', false)
            location.reload();
            $notify('success', 'Visuals Updated', `Visuals ${data.name} successfully updated.`, 5)
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async deleteVisuals(ctx, payload) {
         try {
            ctx.commit('loading', true)

            for (const visuals of ctx.getters.selected_visuals) {
               let res = await api.fetchEndpoint({
                  resource: 'commons',
                  action: 'delete',
                  data: {
                     id: visuals._id,
                  },
                  meta_data: {
                     service: "analytics",
                     collection: "visualization",
                  }
               })
            }

            await ctx.dispatch('fetchVisuals')
            ctx.commit('show_delete_modal', false)
            $notify('success', 'Visuals Deleted', `<b>${ctx.getters.selected_visuals.length}</b> Visuals successfully deleted.`, 5)
            location.reload();
            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      async setSelectFields(ctx,{payload, data}){
         let select_form = {
            selected_option: 'current_table',
            form_data: {},
         }

         if(Array.isArray(payload)){
            let fields = []
            for (let i = 0; i < payload.length; i++) {
               const item = payload[i];
               
               if(item.table && item.table !== ctx.getters.selected_visuals[0].table){
                  select_form.form_data.other_table = item.table
                  select_form.selected_option = 'other_table'

               }

               if(item.criteria){
                  select_form.form_data.criteria = item.criteria
               }
               fields.push(item.field)
            }

            if(Array.isArray(data)){
               select_form.form_data.field = fields
            }else{
               select_form.form_data.field = fields[0] || ''
            }
         }else{
            if(payload.table && payload.table !== ctx.getters.selected_visuals[0].table){
               select_form.selected_option = 'other_table'
            }

            select_form.form_data = {field: payload.field, other_table: payload.table}
            if(payload.criteria){
               select_form.form_data.criteria = payload.criteria
            }
         }

         if(!select_form.form_data.field || select_form.form_data.field  === ''){
            select_form.selected_option = ''
         }

         return select_form
      },
      async resetFields(ctx,payload){
         let select_form = {
            selected_option: 'current_table',
            form_data: {},
         }

         if(Array.isArray(payload)){
            let fields = []

            select_form.form_data.field = []
         }else{
            if(payload.table && payload.table !== ctx.getters.selected_visuals[0].table){
               select_form.selected_option = 'other_table'
            }
            select_form.form_data = {field: payload.field}
         }

         return select_form
      },
      async handleActions(ctx, payload) {
         if (payload.action === 'visuals:edit') {
            ctx.commit('selected_visuals', payload.rows)
            let VisualsModel = ctx.getters.VisualsModel, form = await ctx.dispatch('getVisualFromForm',payload.rows[0].type);
            VisualsModel.forms.nextPageVisualization.forms = VisualsModel.forms[form].forms

            let next_page_data = utils.generateFormData(VisualsModel.forms.nextPageVisualization.forms), edit_data = utils.generateFormData(VisualsModel.forms.editVisuals.forms)
            await ctx.dispatch('fetchTableData',{table_code: payload.rows[0].table})

            // Set the date field only when found
            if(payload.rows[0].date_field){
               payload.rows[0].date_field = await ctx.dispatch('setSelectFields',{payload: payload.rows[0].date_field, data: edit_data.date_field})
            }
            payload.rows[0].x_field = await ctx.dispatch('setSelectFields',{payload: payload.rows[0].x_fields, data: next_page_data.x_fields})
            payload.rows[0].y_field = await ctx.dispatch('setSelectFields',{payload: payload.rows[0].y_fields, data: next_page_data.y_fields})

            // Handle Non Mandatory Fields
            if(payload.rows[0].sort_field){
               payload.rows[0].sort_field = await ctx.dispatch('setSelectFields',{payload: payload.rows[0].sort_field, data: next_page_data.sort_field})
            }
            if(payload.rows[0].aggregation_fields){
               payload.rows[0].aggregation_field = await ctx.dispatch('setSelectFields',{payload: payload.rows[0].aggregation_fields, data: next_page_data.aggregation_fields})
            }

            console.log(payload.rows)
            // Set data on both forms
            VisualsModel.forms.editVisuals.data = payload.rows[0]
            VisualsModel.forms.nextPageVisualization.data = payload.rows[0]
            
            
            console.log(VisualsModel.forms.editVisuals.data)
            ctx.commit('show_edit_modal', true)
            ctx.commit('VisualsModel', VisualsModel)
         } else if (payload.action === 'visuals:delete') {
            ctx.commit('delete_message', `<b>${payload.rows.length}</b> Visuals`)
            ctx.commit('show_delete_modal', true)
            ctx.commit('selected_visuals', payload.rows)
         } else if (payload.action === 'visuals:view') {
            // $session.set('selected_visuals',payload.rows[0])
         }
      },
      async fetchVisuals(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'commons',
               action: 'list',
               data: {
                  rules: {
                     match: {

                     }
                  }
               },
               meta_data: {
                  service: "analytics",
                  collection: "visualization",
               }
            })
            ctx.commit('visuals', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchFormData')
            await ctx.dispatch('fetchVisuals')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
      async fetchFormData(ctx) {
         try {
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {
                     match: {
                        is_accessible: true
                     }
                  }
               },
               meta_data: {service: "analytics",collection: "table"}
            })


            let Model = utils.appendSelectData({
               Model: ctx.getters.VisualsModel,
               forms: ['addVisuals','editVisuals'],
               model: 'table',
               label: 'name',
               dataField: 'code',
               data: res.result.records
            })
            ctx.commit('VisualsModel', Model)

            res = await api.fetchEndpointSecure({
               resource: 'commons',action: 'list',
               data: {
                  rules: {}
               },
               meta_data: {service: "analytics",collection: "dashboard"}
            })


            Model = utils.appendSelectData({
               Model: ctx.getters.VisualsModel,
               forms: ['addVisuals','editVisuals'],
               model: 'dashboard_link',
               label: 'name',
               dataField: '_id',
               data: res.result.records
            })
            ctx.commit('VisualsModel', Model)
         } catch (err) {
            throw err
         }
      },
      async fetchTableData(ctx,{table_code, is_other}) {
         try {
            console.log('Was Here')
            // Fetch Schema
            let res = await api.fetchEndpointSecure({
               resource: 'table',action: 'get:fields_by_type',
               data: { table_code },
               meta_data: {}
            })

            let fields = {
               select: [],
               date: [],
               number: [],
               latitude: [],
               longitude: [],
               region: [],
            }
            let field_obj = {
               'SELECT': (record) => {
                  fields.select = record.fields
               },
               'DATE': (record) => {
                  fields.date = record.fields
               },
               'NUMBER': (record) => {
                  fields.number = record.fields
               },
               'LATITUDE': (record) => {
                  fields.latitude = record.fields
               },
               'LONGITUDE': (record) => {
                  fields.longitude = record.fields
               },
               'REGION': (record) => {
                  fields.region = record.fields
               }
            }

            for (let i = 0; i < res.result.fields.length; i++) {
               const record = res.result.fields[i]
               let selected_field = field_obj[record._id]

               if(selected_field){
                  selected_field(record)
               }
            }

            // Set form fields
            let Model = ctx.getters.VisualsModel
            if(!is_other){
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_date','form_fields_date_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.date})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_all','form_fields_all_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: [...fields.date,...fields.select,...fields.number,...fields.region]})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_latitude'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.latitude})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_longitude'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.longitude})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_region'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.region})
               // Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['addVisuals','editVisuals'],model: 'date_field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.date})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_number','form_fields_number_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.number})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['form_fields_select','form_fields_select_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.select})
               
               Model = utils.appendSelectData({
                  Model: ctx.getters.VisualsModel,
                  forms: [
                     'other_form_fields_date','other_form_fields_number','other_form_fields_select','other_form_fields_all','form_fields_latitude','form_fields_longitude',
                     'form_fields_region',

                     // Multiple Forms
                     'other_form_fields_date_multiple', 'other_form_fields_number_multiple', 'other_form_fields_select_multiple', 'other_form_fields_all_multiple'
                  ],
                  model: 'other_table',
                  label: 'name',
                  dataField: 'code',
                  data: res.result.linked_tables
               })
            }else{
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_date','other_form_fields_date_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.date})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_latitude'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.latitude})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_longitude'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.longitude})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_region'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.region})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_number','other_form_fields_number_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.number})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_all','other_form_fields_all_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: [...fields.date,...fields.select,...fields.number,...fields.region]})
               Model = utils.appendSelectData({Model: ctx.getters.VisualsModel,forms: ['other_form_fields_select','other_form_fields_select_multiple'],model: 'field',label: 'alias',labelSupport: 'name',dataField: 'code',data: fields.select})
            }
            
            ctx.commit('VisualsModel', Model)
         } catch (err) {
            throw err
         }
      },
      async selectFieldChanged(ctx,payload){
         try {
            if(payload.form.model === 'table' && payload.data && payload.data.length > 3){
               ctx.commit('loading',true)
               await ctx.dispatch('fetchTableData',{table_code: payload.data})
               let form = null

               if(ctx.getters.show_edit_modal){
                  form = await ctx.dispatch('getVisualFromForm',VisualsModel.forms.editVisuals.data.type);
               }else{
                  form = await ctx.dispatch('getVisualFromForm',VisualsModel.forms.addVisuals.data.type);
               }
               VisualsModel.forms.nextPageVisualization.forms = VisualsModel.forms[form].forms
               
               let reset = {
                  selected_option: '',
                  form_data: {},
               }
               VisualsModel.forms.addVisuals.data.date_field = reset
               VisualsModel.forms.editVisuals.data.date_field = reset
               VisualsModel.forms.nextPageVisualization.data.x_field = reset
               VisualsModel.forms.nextPageVisualization.data.y_field = reset
               VisualsModel.forms.nextPageVisualization.data.aggregation_field = reset
               ctx.commit('VisualsModel', VisualsModel)

               ctx.commit('loading',false)
            }if(payload.form.model === 'other_table' && payload.data && payload.data.length > 3){
               ctx.commit('loading',true)
               await ctx.dispatch('fetchTableData',{table_code: payload.data, is_other: true})
               ctx.commit('loading',false)
            }
         } catch (err) {
            throw err
         }
      }
   }
};